import selfInviteEmptyListHtml from './selfInviteEmptyListComponent.html';

export default {
  templateUrl: selfInviteEmptyListHtml,
};
